/**
 * Based on Atom's One Dark theme: https://github.com/atom/atom/tree/master/packages/one-dark-syntax
 */

.prism-code-editor {
	font-family: "Fira Code", "Fira Mono", Menlo, Consolas, "DejaVu Sans Mono", monospace;
	--pce-cursor: #528bff;
	--pce-bg: #292c33;
	--pce-widget-border: #3a3f4b;
	--pce-widget-bg: #21252b;
	--pce-widget-color: #ccc;
	--pce-widget-color-active: #fff;
	--pce-widget-color-options: #b2b2b2;
	--pce-widget-bg-input: #1b1d23;
	--pce-widget-bg-hover: #5a5d5e4f;
	--pce-widget-bg-active: #336699;
	--pce-widget-focus: #5299e0;
	--pce-search-match: #528bff3d;
	--pce-widget-bg-error: #5a1d1d;
	--pce-widget-error: #be1100;
	--pce-bg-highlight: #99bbff0a;
	--pce-selection-match: #4a566d66;
	--pce-line-number: #636d83;
	--pce-scrollbar: 220, 13%, 41%;
	--pce-bg-fold: #c5c5c5;
	--pce-guide-indent: #abb2bf26;
	--pce-ac-icon-class: #ee9d28;
	--pce-ac-icon-enum: #ee9d28;
	--pce-ac-icon-event: #ee9d28;
	--pce-ac-icon-function: #b180d7;
	--pce-ac-icon-interface: #75beff;
	--pce-ac-icon-variable: #75beff;
	--pce-selection: #3e4451;
	color-scheme: dark;
}


.pce-match {
	--pce-search-match: #515c6a;
}

.active-line {
	--pce-line-number: #abb2bf;
}

.active-indent {
	--pce-guide-indent: #abb2c280;
}

.token.comment,
.token.prolog,
.token.cdata {
	color: #5c6370;
}

[class*="language-"],
.token.punctuation,
.token.attr-equals,
.language-css .token.property,
.token.url {
	color: #abb2bf;
}

.token.keyword,
.token.token.anchor,
.token.regex-flags,
.selector .punctuation,
.selector .combinator,
.selector .operator,
.token.token.arrow {
	color: #c678dd;
}

.token.class-name,
.token.maybe-class-name {
	color: #e5c07b;
}

.token.attr-name,
.token.doctype,
.selector .class,
.selector .pseudo-element,
.selector .pseudo-class,
.token.regex .escape,
.token.char-class,
.token.char-set,
.token.boolean,
.token.constant,
.token.number,
.token.entity,
.token.unit,
.token.atrule,
.token.keyword-null,
.token.keyword-undefined {
	color: #d19a66;
}

.token.property,
.token.tag,
.token.doctype-tag,
.token.symbol,
.token.deleted,
.token.important,
.token.keyword-this,
.token.this
.token.variable,
.token.selector,
.language-css .variable,
.token.property-access {
	color: #e06c75;
}

.token.string,
.token.char,
.token.inserted,
.token.string-property,
.token.attr-value,
.token.string.url.url,
.token.attr-value:not(.script):not(.style) > .punctuation,
.token.code.code-snippet {
	color: #98c379;
}

.token.url > .variable,
.token.url > .content,
.token.function,
.token.selector .id {
	color: #61afef;
}

.token.regex,
.language-regex,
.token.char-class .operator,
.token.alternation,
.token.quantifier,
.token.hexcode,
.token.keyword-get,
.token.keyword-set,
.token.builtin,
.token.operator {
	color: #56b6c2;
}

/* Language overrides */

.language-css .token.important,
.token.atrule .token.rule,
.language-markdown .italic,
.language-markdown .url > .url,
.token.url.url-reference {
	color: #c678dd;
}

.language-json .token.keyword-null,
.token.bold *,
.token.url-reference .variable,
.token.url-reference .punctuation {
	color: #d19a66;
}

.token.code.keyword,
.language-json .token.operator,
.token.url > .operator {
	color: #abb2bf;
}

.language-css .function,
.token.blockquote,
.token.hr {
	color: #56b6c2;
}



.language-markdown .strike *,
.token.url-reference .string,
.token.list,
.token.title.important > .punctuation {
	color: #e06c75;
}

/* General */
.token.bold {
	font-weight: bold;
}

.token.comment,
.token.italic {
	font-style: italic;
}

.token.namespace {
	opacity: 0.8;
}

/* Brackets */

.token.bracket-level-0,
.token.bracket-level-3,
.token.bracket-level-6,
.token.bracket-level-9 {
	color: #ffd700;
}

.token.bracket-level-1,
.token.bracket-level-4,
.token.bracket-level-7,
.token.bracket-level-10 {
	color: #da70d6;
}

.token.bracket-level-2,
.token.bracket-level-5,
.token.bracket-level-8,
.token.bracket-level-11 {
	color: #179fff;
}

.token.interpolation-punctuation {
	color: #98c379;
}

.token.bracket-error {
	color: #ff1212cc;
}

.token.markup-bracket,
.token.regex .punctuation {
	color: inherit;
}

.active-bracket {
	box-shadow: inset 0 0 0 1px #888, inset 0 0 0 9in #0064001a;
}

.active-tagname,
.word-matches span {
	background: #575757b8;
}
